export const DEFAULT_SEARCH_AND_FILTER_VIEW_PLACEHOLDER = 'DEFAULT_SEARCH_AND_FILTER_VIEW_PLACEHOLDER';